import * as React from "react";
const SvgFiRrLampStreet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lamp-street_svg__a)">
      <path
        fill="#062147"
        d="M23.936 13.788c-.744-3.637-3.833-6.351-7.522-6.74A8.22 8.22 0 0 0 8.25 0C3.701 0 0 3.701 0 8.253l.038 14.75a1 1 0 0 0 1 .997h.003a1 1 0 0 0 .997-1.003L2 8.25A6.257 6.257 0 0 1 8.25 2a6.23 6.23 0 0 1 6.139 5.071c-3.609.463-6.605 3.151-7.333 6.732-.062.309-.21 1.383.501 2.251.354.432 1.045.946 2.33.946h3.112v.5a2.5 2.5 0 1 0 5 0V17h3.108c1.047 0 1.838-.318 2.349-.945.682-.836.562-1.864.479-2.267zm-2.028 1.003c-.107.131-.405.209-.799.209H9.888c-.387 0-.672-.078-.782-.213-.121-.147-.118-.44-.088-.588C9.629 11.186 12.356 9 15.5 9s5.861 2.183 6.477 5.19c.042.204.031.477-.069.601"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lamp-street_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLampStreet;
